module.exports = __webpack_public_path__ + "img/btn_LOW_normal.ab4333e6.png";